import { type UseQueryResult, useQuery } from 'react-query';
import { PsuElectionWindowConfigurationService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { isEmpty } from 'lodash';

const useGetPSUElectionWindowConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): any => {
  const getPSUElectionWindowConfigurationList = useQuery(
    ['getPSUElectionWindowConfigurationList'],
    async () => {
      return await handleRequest(
        PsuElectionWindowConfigurationService.getApiAwardSettlementApiAppPSUElectionWindowConfigurationPSUElectionWindowConfigurationsV2().then(
          (res) => {
            if (res) {
              return {
                ...res,
                defaultSettlementTypeId: !isEmpty(
                  res?.defaultSettlementConfigurationDto?.defaultSettlementTypeId
                )
                  ? res?.defaultSettlementConfigurationDto?.defaultSettlementTypeId
                  : '',
              };
            }
          }
        )
      );
    },
    {
      cacheTime: 1000 * 60 * 5,
    }
  );
  return getPSUElectionWindowConfigurationList;
};

export default useGetPSUElectionWindowConfiguration;
